import type { IconProps } from '../types/IconProps.ts';
export const StopCircle: IconProps = {
    name: 'StopCircle',
    children: [
        `<circle cx="12" cy="12" r="10" />`,
        `<rect width="6" height="6" x="9" y="9" rx="1" />`,
    ]
};